// Firebase App (the core Firebase SDK) is always required and must be listed first
import * as firebase from "firebase/app";

// Add the Firebase products that you want to use
import "firebase/database";

// TODO: Replace the following with your app's Firebase project configuration
const firebaseConfig = {
  apiKey: "AIzaSyCIzNueE8MeUW-UtPq7AsxoxAavB1VmlPM",
  authDomain: "media-awards.firebaseapp.com",
  databaseURL: "https://media-awards.firebaseio.com",
  projectId: "media-awards",
  storageBucket: "media-awards.appspot.com",
  messagingSenderId: "743397481580",
  appId: "1:743397481580:web:ea65466c15d775c2b28c49"
};

// Initialize Firebase
firebase.initializeApp(firebaseConfig);

export default firebase;
